import {
  requestMicroFrontendFetch,
  sendMicroFrontendFetchResponse,
} from '@wellesley/host-remote/api/actions'
import { sendMessage } from '@wellesley/host-remote/common/message/sendMessage'
import { listenMessage } from '@wellesley/host-remote/common/message/listenMessage'
import { serializeRequest, deserializeResponse } from '../serialize'

export const createRemoteFetch = async (options: Request) => {
  const id = crypto.randomUUID()

  return new Promise<Response>((resolve, reject) => {
    const unsubscribe = listenMessage({
      onMessage: ({
        payload: { id: responseId, response },
      }: ReturnType<typeof sendMicroFrontendFetchResponse>) => {
        if (id === responseId) {
          unsubscribe?.()
          resolve(deserializeResponse(response))
        }
      },
      whitelist: [sendMicroFrontendFetchResponse],
    })
    void (async () => {
      try {
        sendMessage({
          action: requestMicroFrontendFetch({
            id,
            options: await serializeRequest(options),
          }),
          windowElement: window.parent,
          whitelist: [requestMicroFrontendFetch],
        })
      } catch (error) {
        reject(error)
      }
    })()
  })
}
